<template>
  <div id="app">
    <SiteHeader v-if="!hideHeader" />
    <router-view />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue';

export default {
  name: 'App',
  components: { SiteHeader },
  computed: {
    hideHeader() {
      return this.$route.meta && this.$route.meta.hideHeader === true;
    }
  }
};
</script>

<style lang="less" src="./assets/common.less">
</style>
